(function () {
  const descriptions = new Set();

  function isTruncated(content) {
    return content.scrollHeight > content.clientHeight + 1;
  }

  function updateDescription(root) {
    const content = root.querySelector('.collection-description__content');
    const checkbox = root.querySelector('.collection-description__checkbox');
    const toggle = root.querySelector('.collection-description__toggle');
    if (!content) return;

    if (checkbox?.checked) {
      root.classList.add('collection-description--truncated');
      toggle?.removeAttribute('hidden');
      checkbox?.removeAttribute('hidden');
      return;
    }

    const truncated = isTruncated(content);
    root.classList.toggle('collection-description--truncated', truncated);
    if (!truncated) {
      if (checkbox) {
        checkbox.checked = false;
        checkbox.setAttribute('hidden', '');
      }
      toggle?.setAttribute('hidden', '');
    } else {
      checkbox?.removeAttribute('hidden');
      toggle?.removeAttribute('hidden');
    }
  }

  function bindDescription(root) {
    if (descriptions.has(root)) return;
    descriptions.add(root);

    const content = root.querySelector('.collection-description__content');
    const checkbox = root.querySelector('.collection-description__checkbox');
    const update = () => updateDescription(root);

    checkbox?.addEventListener('change', update);

    if (content && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(content);
    } else {
      window.addEventListener('resize', update);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(update);
    }
  }

  function initDescriptions() {
    document.querySelectorAll('.collection-description').forEach((root) => {
      bindDescription(root);
      updateDescription(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptions);
  } else {
    initDescriptions();
  }

  window.addEventListener('load', initDescriptions);
  document.addEventListener('shopify:section:load', initDescriptions);
})();
